import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { ColorPicker } from "@progress/kendo-react-inputs";
import { FormControl, InputLabel, Select, OutlinedInput, ListItemText, Checkbox, Button, ButtonGroup, Stack } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import Logo from '../../shared/common-utilities/utils/Logo';
import SettingsIcon from '@mui/icons-material/Settings';
import Divider from '@mui/material/Divider';
import { SidebarData } from '../../shared/common-utilities/utils/SidebarData';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import UpdateIcon from '@mui/icons-material/Update';
import { useDispatch, useSelector } from 'react-redux';
import  axios  from 'axios';
import _ from 'lodash';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { updateOpenReducer } from '../../shared/ReduxStore/Reducers/sideBarReducer';
import { AppBar, Search, SearchIconWrapper, StyledInputBase} from '../../shared/common-utilities/common/CommonStyleComponent';
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Switch, NumericTextBox } from "@progress/kendo-react-inputs";
import { fetchSavedView } from '../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import commonApiService from '../../shared/common-utilities/services/commonApiService';

import getSetDataService from '../../shared/common-utilities/services/getSetDataService';
import AlertComponent from '../../shared/common-utilities/common/AlertComponent';
import dataStorageService from '../../shared/common-utilities/services/DataStorageService';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { updateRefreshTime } from '../../shared/ReduxStore/Reducers/refreshTimeReduce';

const buttonIconData = [
  { label: "SaveIcon", component: <SaveIcon /> },
  { label: "RefreshIcon", component: <RefreshIcon /> },
  { label: "DriveFileRenameOutlineIcon", component: <DriveFileRenameOutlineIcon /> },
  { label: "UpdateIcon", component: <UpdateIcon /> }
];

let apiService = commonApiService();
let service = dataStorageService();
let dataService = getSetDataService();

const Header = (props) => {
  const [index, setIndex] = useState(props.index);
  const [isShowHeaderEle, setIsShowHeaderEle] = useState(true);
  const [isShowSearch, setIsShowSearch] = useState(false);
  const [isShowDatefilters, setIsShowDatefilters] = useState(false);
  const [isShowmovements, setIsShowmovements] = useState(false);

  const [selectedMovementsSum, setselectedMovementsSum] = useState(0);
  const [totalMovementsSum, settotalMovementsSum] = useState(0);
  const [selectedVolumeSum, setselectedVolumeSum] = useState(0);
  const [totalVolumeSum, settotalVolumeSum] = useState(0);
  const [selectedNetWeightSum, setselectedNetWeightSum] = useState(0);
  const [totalNetWeightSum, settotalNetWeightSum] = useState(0);
  const [selectedWeightSum, setselectedWeightSum] = useState(0);
  const [totalWeightSum, settotalWeightSum] = useState(0);
  const [selectedLLSum, setselectedLLSum] = useState(0);
  const [totalLLSum, settotalLLSum] = useState(0);
  const [selectedQuantitySum, setselectedQuantitySum] = useState(0);
  const [totalQuantitySum, settotalQuantitySum] = useState(0);
  const [measureField, setMeasureField] = useState("null");
  const [openModal, setOpenModal] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("rgba(255, 0, 0, 1)");
  const [secondaryColor, setSecondaryColor] = useState("rgba(255, 0, 0, 1)");
  const [statusColor, setStatusColor] = useState("rgba(255, 0, 0, 1)");

  const [selectedBtnIcons, setSelectedBtnIcons] = useState([]);
  const [selectedBtnGroupData, setSelectedBtnGroupData] = useState([]);
  const [username, setusername] = useState('username');
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshSwitch,setRefreshSwitch] = useState(false);
  const [refreshTime,setRefreshTime] = useState(20);
  const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
  const [windowPos, setWindowPos] = useState({ left: 0, top:  0, width: 400, height: 320 });

  const header = useSelector(state => state.updateHeader);
  const partialTripReducerData = useSelector(state => state.partialTrip.partialTrips);
  const navigate = useNavigate()
  useEffect(() => {
    if (localStorage.userName) {
      const user = localStorage.getItem('userName');
      setusername(user);
    }
    let gridRefreshTime = JSON.parse(service.getLocalStorageData('refreshTime'))
    if(gridRefreshTime != null) {
      setRefreshTime(gridRefreshTime)
      setRefreshSwitch(true)
    }
  }, [])

  useEffect(() => {
    let index = 0;
    for (const data of SidebarData) {
      if (window.location.hash.includes(data.path)) {
        index = data.index;
      }
    }
    setIndex(index);

    setIsShowSearch(false)
    if (window.location.hash.includes('movements') || window.location.hash.includes('partial-trip') || window.location.hash.includes('map') || window.location.hash.includes('trip-agenda')) {
      setIsShowDatefilters(true)
      setIsShowmovements(true)
    } else if (window.location.hash.includes('agenda')) {
      setIsShowDatefilters(false)
      setIsShowmovements(true)
    } else {
      setIsShowDatefilters(false)
      setIsShowmovements(false)
    }
  }, [window.location.hash])

  useEffect(() => {
    if (header) {
      setselectedMovementsSum(isNil(header.selectedMovementsSum))
      settotalMovementsSum(isNil(header.totalMovementsSum))

      setselectedVolumeSum(isNil(header.selectedVolumeSum))
      settotalVolumeSum(isNil(header.totalVolumeSum))

      setselectedNetWeightSum(isNil(header.selectedNetWeightSum))
      settotalNetWeightSum(isNil(header.totalNetWeightSum))

      setselectedWeightSum(isNil(header.selectedWeightSum))
      settotalWeightSum(isNil(header.totalWeightSum))

      setselectedLLSum(isNil(header.selectedLLSum))
      settotalLLSum(isNil(header.totalLLSum))

      setselectedQuantitySum(isNil(header.selectedQuantitySum))
      settotalQuantitySum(isNil(header.totalQuantitySum))

      setMeasureField(_.isNil(header.measurementField) ? "" : header.measurementField)
    }
  }, [header])

  const isNil = (val) => {
    if (_.isNil(val) || _.isNaN(val)) {
      return 0
    } else {
      return val;
    }
  };

  useEffect(() => {
    if (!_.isNil(partialTripReducerData)) {
      if (partialTripReducerData.length > 0) {
        if (!_.isNil(partialTripReducerData[0].shipmentMovements)) {
          setselectedMovementsSum(partialTripReducerData[0].shipmentMovements.length)
          setselectedVolumeSum(partialTripReducerData[0].shipmentMovements.reduce((sum, item) => sum + item["volume"], 0))
          setselectedWeightSum(partialTripReducerData[0].shipmentMovements.reduce((sum, item) => sum + item["weight"], 0))
          setselectedNetWeightSum(partialTripReducerData[0].shipmentMovements.reduce((sum, item) => sum + item["netWeight"], 0))
          setselectedLLSum(partialTripReducerData[0].shipmentMovements.reduce((sum, item) => sum + item["loadingLength"], 0))
        }
      }
    }
  }, [partialTripReducerData])


  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const toggleSideBar = useSelector((state) => state.sideBar.toggleSideBar);
  const dispatch = useDispatch()

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    navigate('profile');
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const onLogoutClick = async () => {
    apiService.logOut();
  }

  const onSettingsClick = () => {
    setOpenModal(true);
    dataService.setWindowInitialPosition(400, 320, setWindowPos);
  }

  const onPrimaryColorChange = (event) => {
    setPrimaryColor(event.value);
  }

  const onSecondaryColorChange = (event) => {
    setSecondaryColor(event.value);
  }

  const onStatusColorChange = (event) => {
    setStatusColor(event.value);
  }

  const onButtonIconSelect = (event) => {
    setSelectedBtnIcons(event.target.value);
  }

  const closeModal = () => {
    setOpenModal(false)
    setSelectedTab(0)
  }

  const saveConfigData = async(refreshTime) => {
    const userID = localStorage.getItem('userID')
    const mvUrl = `${fetchSavedView}?$filter=(title eq 'generalSettings' and userID eq '${userID.toUpperCase().replace(/"/g, '')}')`;
    let generalSettings = {
      refreshTime  : refreshTime
    }

    await apiService.get(mvUrl).then(async(res) => {
      if (res?.value?.length !== 0) { // res will return array of value 
        await apiService.put(res.value[0]["userMetadata@odata.mediaReadLink"], res.value[0]["@odata.etag"], generalSettings).then(response => {
          service.setLocalStorageData('refreshTime',refreshTime)
          dispatch(updateRefreshTime(refreshTime))
          setSuccessSnackbarMessage('Operation successful!');
          setSuccessSnackbarOpen(true);
        })
      }
    })
  }

  const applyConfigChanges = async() => {
    if(selectedTab == 1 ) {
      if(refreshSwitch && refreshTime >= 20 && refreshTime <= 99999) {
        saveConfigData(refreshTime)
      } else if(!refreshSwitch) {
        saveConfigData(null)
         console.log("disable setting")
      }
    } else {
      setSelectedBtnGroupData(buttonIconData.filter((item) => selectedBtnIcons.includes(item.label)));
    }
    setOpenModal(false);
    setSelectedTab(0)
  }

  const handleSelectTab = (e) => {
    setSelectedTab(e.selected);
  };

  const onChangeSwitch = (e) => {
    setRefreshSwitch(e.target.value);
  }

  const handleSuccessSnackbarClose = () => {
    setSuccessSnackbarOpen(false);
  };
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      // anchorOrigin={{
      //     vertical: 'top',
      //     horizontal: 'right',
      // }}
      id={menuId}
      keepMounted
      // transformOrigin={{
      //     vertical: 'top',
      //     horizontal: 'right',
      // }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton size="large" aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="error">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton >
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const colCheckboxItemRender = (li, itemProps) => {
    const itemChildren = (
      <span style={{display:'flex',alignItems:'center'}}>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{buttonIconData[itemProps.index]?.component}&nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const onMoveWindow = (event) => {
    dataService.onMoveWindow(event, windowPos, setWindowPos);
  };

  const onResizeWindow = (event) => {
    dataService.onResizeWindow(event, setWindowPos);
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose} />

      <AppBar position="fixed" elevation={3} color="default" sx={{ borderWidth: 0, backgroundColor: '#ffffff', borderBottomWidth: 2, borderStyle: 'solid', borderBottomColor: 'secondary.light', }} >
        <Toolbar variant="dense" disableGutters={false} sx={{ padding: 0 }} >
          <IconButton
            size="medium"
            edge="start"
            color="primary"
            aria-label="open drawer"
            sx={{ mr: 0, left: -8, }}
            onClick={() => dispatch(updateOpenReducer(!toggleSideBar))}
          >
            <AppsIcon sx={{
              display: toggleSideBar ? 'none' : 'block',
            }} />
            <MenuOpenIcon sx={{
              display: toggleSideBar ? 'block' : 'none',
            }} />


          </IconButton>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { sm: 'none', md: 'flex' } }}
          >
            <Logo />
          </Typography>
          {isShowSearch &&
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
              />
            </Search>
          }
          {isShowDatefilters &&
            <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">
              {selectedBtnGroupData.map((item) => (
                <Button key={item.label}>{item.component}</Button>
              ))}
            </ButtonGroup>
          }
          <Box sx={{ flexGrow: 1 }} />

          {isShowmovements &&
            <Stack direction="row" sx={{ flexGrow: 0 }} spacing={.5} justifyContent="" className='maxXm700' mr={1}>
              <Box py={.5} px={1} className='color-one' sx={{ color: 'primary.dark', }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, display: 'inline-flex', whiteSpace: 'nowrap', padding: 0, marginRight: 1, fontSize: 12 }} >
                  Movements
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} component="h5"   >
                  {<span>{selectedMovementsSum} / {totalMovementsSum}</span>}
                </Typography>
              </Box>
              {measureField.includes("Volume") && <Box py={.5} px={1} className='color-two' sx={{ color: 'primary.dark' }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, padding: 0, marginRight: 1, display: 'inline-flex', whiteSpace: 'nowrap', fontSize: 12 }} >
                  Volume (m3)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} component="h5"   >
                  {<span>{selectedVolumeSum.toFixed(2)} / {totalVolumeSum.toFixed(2)}</span>}
                </Typography>
              </Box>}
              {measureField.includes("Weight") && <Box py={.5} px={1} className='color-three' sx={{ width: 'auto', color: 'primary.dark' }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, padding: 0, marginRight: 1, fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} >
                  Weight (kg)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} component="h5"   >
                  {<span>{selectedWeightSum.toFixed(2)} / {totalWeightSum.toFixed(2)}</span>}
                </Typography>
              </Box>}
              {measureField.includes("LoadingLength") && <Box py={.5} px={1} className='color-four' sx={{ color: 'primary.dark' }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, padding: 0, marginRight: 1, fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} >
                  LL (lm)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} component="h5"   >
                  {<span>{selectedLLSum.toFixed(2)} / {totalLLSum.toFixed(2)}</span>}
                </Typography>
              </Box>}
              {measureField.includes("NetWeight") && <Box py={.5} px={1} className='color-four' sx={{ color: 'primary.dark' }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, padding: 0, marginRight: 1, fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} >
                  Net Weight (kg)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, display: 'inline-flex', whiteSpace: 'nowrap', }} component="h5"   >
                  {<span>{selectedNetWeightSum.toFixed(2)} / {totalNetWeightSum.toFixed(2)}</span>}
                </Typography>
              </Box>}
              {measureField.includes("Quantity") && <Box py={.5} px={1} className='color-four' sx={{ color: 'primary.dark', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Typography gutterBottom variant="body2" sx={{ margin: 0, padding: 0, marginRight: 1, fontSize: 12, whiteSpace: 'nowrap' }} >
                  Quantity (No.)
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 12, whiteSpace: 'nowrap' }}    >
                  {<span>{selectedQuantitySum.toFixed(2)} / {totalQuantitySum.toFixed(2)}</span>}
                </Typography>
              </Box>}
            </Stack>
          }

          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {isShowHeaderEle &&
              <>
                {/* <IconButton size="large" sx={{ marginRight: 0 }} aria-label="show 4 new mails" color="primary"
                  onClick={(event) => handleClickEvent(event, index)}
                >
                  <FilterAltIcon />
                </IconButton> */}
                {/* <Divider orientation="vertical" flexItem />
                <IconButton size="large" sx={{ marginRight: 0 }} aria-label="show 4 new mails" color="primary"

                >
                  <SettingsIcon />
                </IconButton> */}
                {/* <Divider orientation="vertical" flexItem /> */}

              </>
            }
            {/* <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton> */}
            <Button className='text-capitalize' sx={{ ml: 0, fontSize: 12, whiteSpace: 'nowrap' }} onClick={handleProfileMenuOpen} startIcon={<AccountCircle color='primary.dark' size="large" />}>
              {username}
            </Button>
            <Divider orientation="vertical" flexItem />
            <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', minWidth: 50, pl: 1, paddingRight: '7px', whiteSpace: 'nowrap' }} >Version {process.env.REACT_APP_VERSION}</Typography>
            <Divider orientation="vertical" flexItem />
            <Button className='text-capitalize' sx={{ ml: 0, minWidth: '45px' }} onClick={onSettingsClick}>
              <SettingsIcon />
            </Button>
            <Divider orientation="vertical" flexItem />
            <Button className='text-capitalize' sx={{ ml: 0, mr: '-15px', pr: 0, minWidth: '45px' }} onClick={onLogoutClick}>
              <LogoutIcon />
            </Button>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}

      {/* open modal for global config data */}
      {openModal && <Window title={"Global Config Data"} className='kendo-popup' modal={true} initialWidth={400} initialHeight={340} minWidth={400} minHeight={320} onClose={() => closeModal()} left={windowPos.left} top={windowPos.top} onMove={onMoveWindow} onResize={onResizeWindow}>
          <TabStrip selected={selectedTab} onSelect={handleSelectTab}>
            <TabStripTab title="General">
              <Box
                sx={{
                  position:'relative',
                  bgcolor: "background.paper",
                }}
              >
                <div style={{ display: "flex", margin: "10px 0px" }}>
                  <Typography variant="body2" gutterBottom sx={{ marginRight: "20px", width: '120px' }}>Primary Color :</Typography>
                  <ColorPicker
                    view="gradient"
                    value={primaryColor}
                    onChange={onPrimaryColorChange}
                    gradientSettings={{ opacity: false }}
                  />
                </div>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <Typography variant="body2" gutterBottom sx={{ marginRight: "20px", width: '120px' }}>Secondary Color :</Typography>
                  <ColorPicker
                    view="gradient"
                    value={secondaryColor}
                    onChange={onSecondaryColorChange}
                    gradientSettings={{ opacity: false }}
                  />
                </div>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <Typography variant="body2" gutterBottom sx={{ marginRight: "20px", width: '120px' }}>Status Color :</Typography>
                  <ColorPicker
                    view="gradient"
                    value={statusColor}
                    onChange={onStatusColorChange}
                    gradientSettings={{ opacity: false }}
                  />
                </div>
                {isShowDatefilters &&
                  <>
                    <InputLabel>Select Multiple Icon:</InputLabel>
                    <MultiSelect
                      data={buttonIconData.map(item => item.label)}
                      itemRender={colCheckboxItemRender}
                      value={selectedBtnIcons}
                      onChange={onButtonIconSelect}
                      rounded={"large"}
                      placeholder='Select Multiple Icon'
                    />
                  </>
                }
              </Box>
            </TabStripTab>
            <TabStripTab title="Auto Refresh">
              <Box sx={{ p: 0, pb: 2 }}>
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <Typography variant="body2" gutterBottom sx={{ marginRight: "20px", width: '120px' }}>Auto Refresh :</Typography>
                  <Switch
                    style={{ outlined: 0 }}
                    onLabel={""}
                    offLabel={""}
                    defaultChecked={refreshSwitch}
                    onChange={onChangeSwitch}
                  />
                </div>
              </Box>
              {refreshSwitch && (
                <div style={{ display: "flex", marginBottom: "10px" }}>
                  <Typography variant="body2" gutterBottom sx={{ marginRight: "20px", width: '100px' }}>Auto Refresh Seconds:</Typography>
                  <Box>
                    <NumericTextBox
                      format="n"
                      min={20}
                      max={99999}
                      autoComplete="off"
                      value={refreshTime}
                      step={5}
                      valid={refreshTime < 99999 && refreshTime > 20}
                      onChange={(e) => setRefreshTime(e.value)}
                      // onBlur={(value) => onDayChange(component, value)}
                    />
                  </Box>
                </div>
              )}
            </TabStripTab>
          </TabStrip>
          
          <WindowActionsBar>
            <Button variant="contained" onClick={applyConfigChanges}>
              Apply
            </Button>
          </WindowActionsBar>
      </Window>}
    </Box>
  )
}


export default Header;
